<template>
  <DialogHeader>
    <template #right>
      <div
        v-if="!loading"
        class="font-medium text-green-900 cursor-pointer"
        @click="handleSubmit"
      >
        Save
      </div>
      <Icon
        v-else
        name="Loading"
        :size="14"
        class="stroke-gray-800 animate-spin"
      />
    </template>
    Change your title
  </DialogHeader>
  <DialogContent>
    <UiInput v-model="title" label="Title" />
  </DialogContent>
  <DialogFooter>
    <UiButton
      class="w-1/2 tablet-h:w-auto mr-2.5 tablet-h:mr-2"
      @click="close()"
    >
      Cancel
    </UiButton>
    <UiButton
      class="w-1/2 tablet-h:w-auto"
      primary
      :loading="loading"
      @click="handleSubmit"
    >
      Change title
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton, UiInput, Icon } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import { ref } from 'vue'
import {
  useUpdateAccountTitleMutation,
  type User,
} from '@/shared/graphql/legacy/generated'
import { ToastType, useToastStore } from '@/shared/stores/toast'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'

const { close } = useDialog()
const toastStore = useToastStore()
const webviewStore = useWebviewStore()

const props = defineProps<{
  user: User
}>()

const { mutate: updateAccountTitle, loading } = useUpdateAccountTitleMutation()

const title = ref(props.user.title || '')

const handleSubmit = async () => {
  updateAccountTitle(
    {
      title: title.value,
    },
    {
      optimisticResponse: {
        __typename: 'Mutation',
        updateAccountTitle: {
          __typename: 'User',
          id: props.user.id,
          title: title.value,
        },
      },
      update() {
        if (webviewStore.isActive) {
          webviewStore.postMessage({
            type: NativeActionsEnum.UserUpdated,
            data: {
              user: {
                ...props.user,
                title: title.value,
              },
            },
          })
        }
      },
    }
  )

  toastStore.showToast({
    type: ToastType.Success,
    content: 'Your title has updated',
  })

  close()
}
</script>
